import "core-js/modules/es.array.map.js";
import React from 'react';
import { CardInner } from '../../../commons/CardInner';
import { Option } from '../Option';
import { Inner } from './partials';
export var Options = function Options(props) {
  return React.createElement(Inner, {
    open: props.open
  }, React.createElement(CardInner, {
    posX: "bottom",
    posY: "left",
    arrowPos: 0,
    type: "entity"
  }, props.options.map(function (option, key) {
    return React.createElement(Option, {
      key: key,
      id: option.id,
      label: option.label,
      onClick: function onClick(_ref) {
        var id = _ref.id,
          label = _ref.label;
        props.onChange({
          id: id,
          label: label
        });
      }
    });
  })));
};